export default "__VITE_ASSET__Cv61MHV7__"